import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface Service {
  id: string;
  title: string;
  description: string;
  category: string;
  estimatedTime: string;
  fee: string;
}
interface ServiceCardProps {
  service: Service;
  buttonText?: string;
}
export const ServiceCard: React.FC<ServiceCardProps> = ({
  service,
  buttonText = 'Request Service'
}) => {
  return <div className="bg-white rounded-lg border border-gray-200 hover:border-blue-500 hover:shadow-sm transition-all duration-200 w-full h-full flex flex-col" data-id="element-361">
      <div className="p-5 flex flex-col flex-1" data-id="element-362">
        <div className="flex-1" data-id="element-363">
          <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-364">
            {service.title}
          </h3>
          <p className="text-sm text-gray-600 mb-6" data-id="element-365">{service.description}</p>
        </div>
        <div className="mt-auto" data-id="element-366">
          <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4" data-id="element-367">
            <div className="flex items-center" data-id="element-368">
              <span className="text-gray-400 mr-2" data-id="element-369">⏱</span>
              <span data-id="element-370">{service.estimatedTime}</span>
            </div>
            <div className="flex items-center" data-id="element-371">
              <span className="text-gray-400 mr-2" data-id="element-372">💰</span>
              <span data-id="element-373">{service.fee}</span>
            </div>
          </div>
          <button className="w-full inline-flex items-center justify-center px-4 py-3 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors duration-150" data-id="element-374">
            {buttonText} <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-375" />
          </button>
        </div>
      </div>
    </div>;
};